module.exports = __webpack_public_path__ + "static/media/icon.d30a9649.png";


//////////////////
// WEBPACK FOOTER
// ./src/icon.png
// module id = 1216
// module chunks = 0